<kodit-page>
    <kodit-table [tableConfig]="tableConfig" [paginatedData]="paginatedData"></kodit-table>
</kodit-page>
